// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"dbe1bf34","503":"eadb6ab8"}[chunkId] + ".chunk.css";
};